import { apiGet, apiPut } from "./client";
import type { PortalsConfig } from "@career-ops-amplify/shared";

export interface PortalsResponse {
  portals: PortalsConfig | null;
}

export type DiscoveryProfilePatch = Partial<
  Pick<
    PortalsConfig,
    | "trackedCompanies"
    | "titleFilter"
    | "locationFilter"
    | "seniorityBoost"
    | "jobBoards"
  >
>;

/** Load the user's discovery profile (tracked companies + default filters). */
export async function getDiscoveryProfile(): Promise<PortalsConfig | null> {
  const res = await apiGet<PortalsResponse>("/api/portals");
  return res.portals;
}

/** Save discovery profile fields (merge on server). */
export async function saveDiscoveryProfile(
  patch: DiscoveryProfilePatch,
): Promise<PortalsConfig> {
  const res = await apiPut<PortalsResponse>("/api/portals", patch);
  if (!res.portals) {
    throw new Error("Failed to save discovery profile");
  }
  return res.portals;
}
